import { Box, Skeleton } from "@chakra-ui/react";
import React from "react";

function SkeletonLoader() {
  return (
    <Box w={"100%"}>
      <Skeleton
        height="32px"
        bg={"gray.200"}
        borderRadius={"20px"}
        width="50%"
      />
      <Skeleton height="60vh" borderRadius={"20px"} width="100%" mt={2} />
      {/* <Skeleton height="30px" width="100px" mt={2} /> */}
    </Box>
  );
}

export default SkeletonLoader;
